import { render, staticRenderFns } from "./usp.html?vue&type=template&id=4a90874b&scoped=true&external"
import script from "./Usp.vue?vue&type=script&lang=js"
export * from "./Usp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90874b",
  null
  
)

export default component.exports